import(/* webpackMode: "eager" */ "/app/app/components/common/GTagEvent.js");
import(/* webpackMode: "eager" */ "/app/app/components/common/ProductSlider.js");
import(/* webpackMode: "eager" */ "/app/app/components/pages/blog/ShareSocialNetwork.js");
import(/* webpackMode: "eager" */ "/app/app/styles/components/common/breadcrumbs.module.scss");
import(/* webpackMode: "eager" */ "/app/app/styles/components/pages/blog/blog-single-page.module.scss");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")